var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full min-w-0"},[_c('div',{staticClass:"flex w-full min-w-0 overflow-x-auto gap-7 tabs-container"},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,class:[
        'flex justify-center items-center p-3 gap-2',
        (option.disabled) ? 'cursor-not-allowed' : 'cursor-pointer',
        _vm.selectedOption === option.value
          ? 'selected-tab'
          : 'text-black dark:text-white'
      ],on:{"click":function($event){!option.disabled && _vm.onSelect(option)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }